<template>
  <div class="login-wrap" id="home">
    <div
            class="Loading__bar___21yOt"
            style="background: rgb(255,255,255); width: 0%;height:2px;transition: width .35s;position: fixed;top:0"
    ></div>
    <div class="box login_box">
      <div class="left-title">
        <p>welcome</p>
        <p>加盟星后台管理系统</p>
      </div>
      <div class="rightbox">
        <div class="left">
          <h3>登 录</h3>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
            class="demo-ruleForm"
          >
            <el-form-item prop="username" class="username">
              <el-input v-model="ruleForm.username" placeholder="请输入用户名">
                <i slot="prefix" class="el-input__icon el-icon-person"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password" class="password">
              <el-input
                type="password"
                placeholder="请输入密码"
                v-model="ruleForm.password"
                @keyup.enter.native="submitForm('ruleForm')"
              >
                <i slot="prefix" class="el-input__icon el-icon-pass"></i>
              </el-input>
            </el-form-item>

            <div class="submit">
              <el-button
                size="medium"
                type="primary"
                @click="submitForm('ruleForm')"
                >登录</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "../assets/css/login.css";
import { mapMutations } from "vuex";

export default {
  data: function () {
    return {
      b_name: "加盟星后台管理系统",
      ruleForm: {
        username: "",
        password: "",
        verification: "",
        checked: "",
      },
      src: "",
      isLoaded: false,
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "blur",
          },
          {
            min: 3,
            message: "用户名必须大于3位",
            trigger: "blur,change",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 6,
            message: "密码必须大于6位",
            trigger: "blur,change",
          },
        ],
        verification: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          {
            min: 4,
            message: "验证码必须是4位",
            trigger: "blur,change",
          },
        ],
      },
    };
  },
  mounted() {
    this.getBus();

    // 兼容ie浏览器
    var ieNum = document.documentMode;
    if (ieNum == 10 || ieNum == 11) {
      document.getElementsByClassName("login_box")[0].style.top = "0";
      document.getElementsByClassName("login_box")[0].style.transform = "none";
    }
  },
  methods: {
    ...mapMutations("navTabs", ["closeAllTab"]),
    getBus() {
      let that = this;
      this.$ajax.get("admin/Login/bus").then(function (res) {
        if (res.data.error === 0) {
          document.title = that.b_name = res.data.data.b_name;
          localStorage.setItem("org_b_name", res.data.data.b_name);
        }
      });
    },
    submitForm(formName) {
      const self = this;
      self.$refs[formName].validate((valid) => {
        if (valid) {
          self.$ajax
            .post("/admin/Login/login", self.ruleForm)
            .then(function (res) {
              if (res.data.error === 0) {
                localStorage.setItem("org_user_name", res.data.data.user_name);
                localStorage.setItem("org_ps_name", res.data.data.ps_name);
                localStorage.setItem(
                  "org_school_name",
                  res.data.data.school_name
                );

                self.closeAllTab();
                self.$router.push("/index.html");
              } else {
                self.$message.error(res.data.message);
              }
            })
            .catch(function (err) {
              self.$message("网络错误！请联系管理员");
            });
        } else {
          return false;
        }
      });
    },
    // getCode() {
    //   getCodeImg().then((res) => {
    //     this.codeUrl = "data:image/gif;base64," + res.img;
    //     this.loginForm.uuid = res.uuid;
    //   });
    // },
  },
};
</script>
<style>
/* 兼容ie9登录页上下不居中问题 */

.login_box {
  top: 50%\9;
  transform: translateY(-50%) \9;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue